module.exports = __webpack_public_path__ + "static/media/F2m-loader_reverse.5878f960.svg";